import { render } from "./Jsjb_handInput.vue?vue&type=template&id=0db62a79"
import script from "./Jsjb_handInput.vue?vue&type=script&lang=js"
export * from "./Jsjb_handInput.vue?vue&type=script&lang=js"

import exportComponent from "E:\\IdeaProjects\\jgwgxt-qt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__